import Axios from 'axios';
import queryString from 'query-string';
import { batch } from 'react-redux';

import { accountIdSelector } from 'store/user/selectors';
import { upload } from 'utils/axios';
import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';
import { decamelizeKeys } from 'utils/humps';

import { ownershipSelector, nextPageSelector, searchSelector, searchFiltersSelector } from './selectors';

import { clearAssetsList, loadNewChunk, setGlobalLoader, setSearchFiltersAction } from './index';

const mapping = {
  all: 'all',
  sp: 'portal',
  my: 'private',
};

const decoratedAxiosGet = axiosGetAutoCancelDecorator();
export const loadAssetsListThunk =
  (module, needToGlobalLoader = true, force = false, resetPage = false) =>
  async (dispatch, getState) => {
    const nextPageNum = resetPage ? 1 : nextPageSelector(getState());

    if (!force && nextPageNum === null) {
      return;
    }

    const accountId = encodeURIComponent(accountIdSelector(getState()));
    const search = searchSelector(getState());
    const { media } = searchFiltersSelector(getState());
    const ownership = ownershipSelector(getState());
    const query = queryString.stringify(
      {
        type: module,
        page: nextPageNum || 1,
        q: search || media?.data?.tags.join(' '),
        ownership: media?.data?.show ? mapping[media?.data?.show] : ownership === 'all' ? '' : ownership,
        countless: '1',
      },
      { skipNull: true, skipEmptyString: true },
    );

    try {
      const { data } = await decoratedAxiosGet(`/acc/${accountId}/assets?${query}`);

      batch(() => {
        if (force) {
          dispatch(clearAssetsList());
        }

        dispatch(loadNewChunk(data));

        if (needToGlobalLoader) {
          dispatch(setGlobalLoader(false));
        }
      });
    } catch (err) {
      if (!(err instanceof Axios.Cancel)) {
        if (needToGlobalLoader) {
          dispatch(setGlobalLoader(false));
        }

        throw err;
      }
    }
  };

export const deleteThunk = (module, id) => async (dispatch, getState) => {
  dispatch(setGlobalLoader(true));

  const accountId = accountIdSelector(getState());
  await upload(`/acc/${accountId}/assets/${id}`, 'DELETE').catch((err) => {
    return err?.errors;
  });

  await dispatch(clearAssetsList());
  await dispatch(loadAssetsListThunk(module, true, true));
};

const decoratedAxiosGetSearchFilters = axiosGetAutoCancelDecorator();
export const getSearchFiltersThunk =
  (page = 'content_library') =>
  async (dispatch, getStore) => {
    const accountId = accountIdSelector(getStore());

    try {
      const response = await decoratedAxiosGetSearchFilters(`/acc/${accountId}/search_filters?dashboard=${page}`);
      const decamelizedData = decamelizeKeys(response?.data?.data);
      const keyMapData = decamelizedData.reduce((res, cur) => {
        res[cur.table] = cur;

        return res;
      }, {});

      dispatch(setSearchFiltersAction(keyMapData));
    } catch (err) {
      if (!(err instanceof Axios.Cancel)) {
        throw err;
      }
    }
  };
